import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../weeksLitterAction';
import fetchApi from "./fetchApi";

function fetchWeeksLitterAction() {
  return fetchApi('/v1/fc_api/weeks_litter_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchWeeksLitterAction;
